import useUserDetails from "@ch/helpers/hooks/useUserDetails";
import useWebPushNotifications from "@ch/helpers/hooks/useWebPushNotifications";
import { NotifyInfo } from "@ch/helpers/utils/helpers";
import { AuthRoutesEnum } from "@ch/router/AuthRoutes/enums";
import type { FC, ReactNode } from "react";
import { Navigate, generatePath, useLocation } from "react-router-dom";

function WebPushNotificationsWrapper() {
  useWebPushNotifications();
  return null;
}

interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute: FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation();
  const { isLoggedIn, hasRequiredPersonalInfo } = useUserDetails();

  if (!isLoggedIn) {
    return (
      <Navigate replace state={{ from: location }} to={AuthRoutesEnum.LOGIN} />
    );
  }

  if (!hasRequiredPersonalInfo) {
    NotifyInfo("Please update your personal information");
    return (
      <Navigate
        replace
        state={{ from: location }}
        to={generatePath(AuthRoutesEnum.PERSONAL_INFORMATION_DETAILS)}
      />
    );
  }

  return (
    <>
      <WebPushNotificationsWrapper />
      {children}
    </>
  );
};

export default PrivateRoute;
